import idlImport from './prod_icpbunny.did.js';
export const idlFactory = idlImport;
export const canisterId = "xkbqi-2qaaa-aaaah-qbpqq-cai";
